import { defineStore } from 'pinia'

import actions from './actions.js'
import getters from './getters.js'

export const useBasketStore = defineStore('basket', {
    namespaced: true,
    state: () => ({
        updateBasketAbortController: new AbortController(),
        isLoading: false,
        isSubmitting: false,
        promo: {
            promoCode: '',
            validated: false,
            status: {
                type: '',
                message: '',
            },
        },
        basket: {
            is_install_basket: false,
            item_count: null,
            shipping_first_name: undefined,
            shipping_last_name: undefined,
            basket_items: [],
            do_subscribe: undefined,
            basket_is_subscribable: false,
            all_items_subscribed: undefined,
            has_free_delivery: undefined,
            initial_subscription_name: undefined,
            subscription_frequency_period: undefined,
            subscription_customer_order_reference: undefined,
            subscription_po_expiry: null,
            subscription_next_date: null,
            unformatted_totals: {
                free_delivery_min_order: null,
                sub_total: null,
                total: null,
                vat_total: null,
                subscription_total: null,
                savings: null,
                promo_savings: {
                    automatic: { total: 0, items: [] },
                    voucher: { total: 0, items: [] },
                },
            },
            delivery_address: {}, 
            user: {},
            card: {},
            promo: {
                promoCode: '',
                validated: false,
                status: {
                    type: '',
                    message: '',
                },
            },
            po_number: null,
            payment_method: null,
            subscription_date_estimates: {
                latest_delivery_date: null,
                estimated_next_date: null,
            }
        },
    }),
    actions,
    getters
})
